export const ButtonsTab = ({
    onDownloadPdf,
    onClickUploadActivities,
    errors,
    tamReadyCount = 0,
    tamFilesCount = 0,
}: {
    onDownloadPdf: any;
    onClickUploadActivities: any;
    errors: any;
    tamReadyCount?: number;
    tamFilesCount?: number;
}) => {

    interface DownloadCardProps {
        id: string,
        title: string;
        icon: string;
        description: string;
        onClickAction: () => void;
        alert?: string;
        disableMessage?: string;
        disable?: boolean;
    }

    const tamUploadHint =
        tamFilesCount > 0 && tamReadyCount > 0
            ? `Al cargar actividades también se subirán ${tamReadyCount} TAM(s) listos.`
            : tamFilesCount > 0
                ? 'Hay TAM(s) cargados; asócialos en la pestaña TAM antes de consolidar.'
                : undefined;

    const cards: DownloadCardProps[] = [
        {
            id: '1',
            title: 'Cargar Actividades',
            icon: '/assets/icons/upload_icon.svg',
            description: 'Por esta via se podra subir las actividades para ser consolidadas',
            alert: tamUploadHint,
            onClickAction: onClickUploadActivities,
        },
        {
            id: '2',
            title: 'Reportes Cartas',
            icon: '/assets/icons/field-report.svg',
            description: 'Estos son los archivos de carta en formato jpg',
            alert: 'Recuerda respaldar esta información pues nose guardara en ninguna DB',
            onClickAction: onDownloadPdf
        },
    ]

    const DownloadCard = (props: DownloadCardProps) => {
        return (
            <button
                type="button"
                className={`card_container card_container--action ${props.disable ? 'disabled_card' : ''}`}
                disabled={props.disable}
                onClick={() => {
                    console.log('[ButtonsTab] click en tarjeta:', props.title);
                    props.onClickAction();
                }}
            >
                <img src={props.disable ? '/assets/icons/dissable-upload.svg' : props.icon} width={60} height={60} alt='' />
                <div className={`card_container__title ${props.disable ? 'disabled_card' : ''}`}>{props.title}</div>
                <div className='card_container__description'>{props.description}</div>
                {props.disable && (
                    <div className='card_container__disabledSection'>
                        <img src="/assets/icons/error.svg" width={20} height={20} alt='' />
                        {props.disableMessage}
                    </div>
                )}
                {props.alert && (
                    <div className='card_container__alertSection'>
                        <img src="/assets/icons/info.svg" width={20} height={20} alt='' />
                        {props.alert}
                    </div>
                )}
            </button>
        )
    }

    const errorCount = Object.keys(errors ?? {}).reduce((count, key) => {
        const items = errors[key];
        if (!Array.isArray(items)) return count;
        return count + items.filter((e: any) => e.type === 'error').length;
    }, 0);

    return (
        <div className='upload_container'>
            {errorCount > 0 && (
                <p className="upload_container_validation_hint">
                    Hay {errorCount} error(es) de validación. Puedes abrir Cargar Actividades para ver el detalle antes de subir.
                </p>
            )}
            <div className='upload_container_cards_section'>
                {cards.map((card) => (
                    <DownloadCard
                        key={card.id}
                        icon={card.icon}
                        title={card.title}
                        description={card.description}
                        alert={card.alert}
                        id={card.id}
                        onClickAction={card.onClickAction}
                        disable={card.disable}
                        disableMessage={card.disableMessage}
                    />
                ))}
            </div>
        </div>
    )
}

function collectBlockingErrors(errors: Record<string, any[]>): string[] {
    const messages: string[] = [];
    Object.keys(errors ?? {}).forEach((key) => {
        errors[key]?.filter((e) => e.type === 'error').forEach((e) => {
            if (e.error && !messages.includes(e.error)) {
                messages.push(e.error);
            }
        });
    });
    return messages;
}

export { collectBlockingErrors };
